import { useCallback, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";

import { List } from "twyne-new.ui";

import { useChangeHistory } from "../../store";

import Pagination, { usePagination } from "./Pagination";
import Version from "./Version";
import { useGrouping, useEntity } from "./utils";

export default function Versions({ entityName, entityCollection }) {
  const { id: entityId } = useParams()
  const { options, reset: resetPagination, onNextPage } = usePagination()
  const { collections: { items: changes, useLoad: useLoadChanges, reset: resetChanges }, collection: { fetchById: fetchChanges, save: saveChanges } } = useChangeHistory()
  const { setItem, fetchById, history: { preview, setPreview } } = entityCollection
  const { id, name } = useEntity(entityId, entityName, entityCollection)
  const groupedChanges = useGrouping(changes)

  const params = useMemo(() => ({
    entityId: id,
    entityName: name,
    options,
    autoRefresh: false,
    cache: false,
  }), [id, name, options])

  useLoadChanges(params)

  useEffect(() => () => {
    resetChanges()
    resetPagination()
  }, [resetPagination, resetChanges])

  const handleView = useCallback(async changes => {
    const preview = await fetchChanges(changes.id, { entityName: name })
    setPreview(changes)
    setItem(preview)
  }, [fetchChanges, setPreview, setItem, name])

  const handleReset = useCallback(async () => {
    setPreview(null)
    setItem(null)
    if (entityId) {
      await fetchById(entityId)
    }
  }, [entityId, fetchById, setPreview, setItem])

  const handleSave = useCallback(async changes => {
    await saveChanges(changes)
  }, [saveChanges])

  if (!groupedChanges.length) {
    return <div className="w-full flex items-center justify-center p-3 text-base font-normal">
      No versions to show.
    </div>;
  }

  return <List className="overflow-y-auto p-1 max-h-[80vh]">
    {groupedChanges.map(group => <Version key={group.group} group={group.group} versions={group.versions}
      preview={preview} onView={handleView} onReset={handleReset} onSave={handleSave} />)}
    <Pagination onNextPage={onNextPage} />
  </List>
}
